import React from "react";
import { Table, Form, Button, InputGroup } from "react-bootstrap";
import { truncateToTwoDecimals } from "../../../../utils/numberFormatter";
import NumberInDecimals from "../../../../components/inputs/NumberFormatted";
const BCPayments = ({
  floatPayment,
  editableRow,
  editedData,
  currencyName,
  currencySymbol,
  balance_now,
  validated,
  CustomInput,
  CustomDatePicker,
  handleEditAmountValue,
  handleSaveEdit,
  handleEditClick,
  handleDeletePayment,
  handleEditIssuedDate,
  setEditableRow,
  setEditedData,
}) => {
  return (
    <div className="mt-3">
      <Table bordered hover responsive className="fixed-inputs-table">
        <thead>
          <tr>
            <th className="p-2">Type</th>
            <th className="p-2">Transaction Number</th>
            <th className="p-2">Account Name</th>
            <th className="p-2">Amount</th>
            <th className="p-2">Cheque Number</th>
            <th className="p-2">Maturity Date</th>
            <th className="p-2">Action</th>
          </tr>
        </thead>

        {floatPayment.length > 0 ? (
          <tbody>
            {floatPayment.map((data, i) => (
              <tr key={i}>
                <td>{data.paymentMethod || "---"}</td>

                <td>{data?.transactionNumber || "---"}</td>

                <td>{data.accountName || "---"}</td>

                <td>
                  {editableRow === i ? (
                    <InputGroup>
                      <InputGroup.Text>
                        {currencySymbol[currencyName] || ""}
                      </InputGroup.Text>

                      <NumberInDecimals
                        className="form-control"
                        value={editedData.amount}
                        decimals={2}
                        onChange={handleEditAmountValue}
                        onKeyDown={(e) =>
                          e.key === "Enter" && handleSaveEdit(i)
                        }
                      />
                    </InputGroup>
                  ) : (
                    <InputGroup>
                      <InputGroup.Text>
                        {currencySymbol[currencyName] || ""}
                      </InputGroup.Text>

                      <Form.Control
                        type="text"
                        className="pointer-events-none"
                        value={truncateToTwoDecimals(data.amount)}
                        readOnly
                      />
                    </InputGroup>
                  )}
                </td>

                <td>
                  {editableRow === i ? (
                    <Form.Control
                      type="text"
                      value={editedData.checkNumber}
                      placeholder="---"
                      onChange={(e) =>
                        setEditedData((prev) => ({
                          ...prev,
                          checkNumber: e.target.value,
                        }))
                      }
                      onKeyDown={(e) => e.key === "Enter" && handleSaveEdit(i)}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      className="pointer-events-none"
                      value={data.checkNumber || "---"}
                      readOnly
                    />
                  )}
                </td>

                <td>
                  <CustomDatePicker
                    index={i}
                    label="Issued Check Date"
                    selected={
                      editableRow === i
                        ? editedData.issuedDate
                          ? new Date(editedData.issuedDate)
                          : null
                        : data.issuedDate
                          ? new Date(data.issuedDate)
                          : null
                    }
                    handleDateChange={(date) => handleEditIssuedDate(date, i)}
                    CustomInput={CustomInput}
                    isRequired
                    validated={validated}
                    disabled={data.paymentMethod === "Cash"}
                  />
                </td>

                <td className="text-center d-flex">
                  {editableRow === i ? (
                    <>
                      <Button
                        size="sm"
                        variant="outline-success"
                        className="me-1"
                        onClick={() => handleSaveEdit(i)}
                        disabled={balance_now < 0}>
                        <i className="fa-solid fa-check"></i>
                      </Button>

                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => setEditableRow(null)}>
                        <i className="fa-solid fa-xmark"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="me-1"
                        onClick={() => handleEditClick(i, data)}>
                        <i className="fa-solid fa-edit"></i>
                      </Button>

                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => handleDeletePayment(i)}>
                        <i className="fa-solid fa-trash"></i>
                      </Button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <caption className="text-center mt-3">
            There are no records to display
          </caption>
        )}
      </Table>
    </div>
  );
};

export default BCPayments;
